export default {
  en: {
    products: {
      products: {
        lectures:{
          title: 'Lections',
          description: 'Learn with our self-made lectures and get access to all the destilled knowledge.',
        },
        trainers:{
          title: 'Trainers',
          description: 'Spelling and listening exercises to become fluent in aviation English.',
        },
        simulator:{
          title: 'Simulator',
          description: 'Practicing in a simulator is a great way to speaking without requiring to be in the sky or in a classroom.',
        },
        questions:{
          title: 'Exam Preparation',
          description: 'Access the official ECQB-PPL questions and answers in a modern layout.',
        },
        api:{
          title: 'API-Access',
          description: 'Get access to our API and integrate it into your own applications.',
        },
        tools :{
          title: 'Tools',
          description: 'Various tools to make your life as a pilot easier.',
        },
      },
      singlepage: {
        product: 'Product',
        configure: 'Configure',
        quantity: 'Quantity',
        subscribe: 'Subscribe',
        buy: 'Buy',
        pricing: 'Pricing',
        waver: 'I agree that LATC will grant access immediately and that I thereby waive my right of withdrawal.',
        rightwithdrawal: 'Right of withdrawal',
        addpaymentmethod: 'Add payment method',
      }
    },
  },
  de: {
    products: {
      products: {
        lectures:{
          title: 'Lektionen',
          description: 'Lernen Sie mit unseren selbst erstellten Lektionen und erhalten Sie Zugang zu all dem destillierten Wissen.',
        },
        trainers:{
          title: 'Trainer',
          description: 'Rechtschreib- und Hörübungen, um fließend Englisch in der Luftfahrt zu sprechen.',
        },
        simulator:{
          title: 'Simulator',
          description: 'Das Üben in einem Simulator ist eine großartige Möglichkeit, das Sprechen zu üben, ohne in der Luft oder im Klassenzimmer sein zu müssen.',
        },
        questions:{
          title: 'Prüfungsvorbereitung',
          description: 'Greifen Sie auf die offiziellen ECQB-PPL-Fragen und -Antworten in einem modernen Layout zu.',
        },
        api:{
          title: 'API-Zugang',
          description: 'Erhalten Sie Zugang zu unserer API und integrieren Sie sie in Ihre eigenen Anwendungen.',
        },
        tools :{
          title: 'Werkzeuge',
          description: 'Verschiedene Werkzeuge, die Ihr Leben als Pilot erleichtern.',
        },
      },
      singlepage: {
        product: 'Produkt',
        configure: 'Konfigurieren',
        quantity: 'Menge',
        subscribe: 'Abonnieren',
        buy: 'Kaufen',
        pricing: 'Preise',
        waver: 'Ich stimme zu, dass LATC sofort Zugang gewährt und ich dadurch mein Widerrufsrecht verliere.',
        rightwithdrawal: 'Widerrufsrecht',
        addpaymentmethod: 'Zahlungsmethode hinzufügen',
      }
    },
  },
  es: {
    products: {
      products: {
        lectures:{
          title: 'Lecciones',
          description: 'Aprenda con nuestras lecciones hechas a mano y obtenga acceso a todo el conocimiento destilado.',
        },
        trainers:{
          title: 'Entrenadores',
          description: 'Ejercicios de ortografía y escucha para hablar con fluidez el inglés de la aviación.',
        },
        simulator:{
          title: 'Simulador',
          description: 'Practicar en un simulador es una excelente manera de hablar sin necesidad de estar en el cielo o en un aula.',
        },
        questions:{
          title: 'Preparación para el examen',
          description: 'Acceda a las preguntas y respuestas oficiales de ECQB-PPL en un diseño moderno.',
        },
        api:{
          title: 'Acceso a la API',
          description: 'Obtenga acceso a nuestra API e intégrela en sus propias aplicaciones.',
        },
        tools :{
          title: 'Herramientas',
          description: 'Varias herramientas para facilitar su vida como piloto.',
        },
      },
      singlepage: {
        product: 'Producto',
        configure: 'Configurar',
        quantity: 'Cantidad',
        subscribe: 'Suscribirse',
        buy: 'Comprar',
        pricing: 'Precios',
        waver: 'Acepto que LATC conceda acceso inmediatamente y que por ello renuncio a mi derecho de desistimiento.',
        rightwithdrawal: 'Derecho de desistimiento',
        addpaymentmethod: 'Agregar método de pago',
      }
    },
  },
  uk: {
    products: {
      products: {
        lectures:{
          title: 'Лекції',
          description: 'Навчайтеся за допомогою наших власних лекцій і отримуйте доступ до всіх знань.',
        },
        trainers:{
          title: 'Тренажери',
          description: 'Вправи з правопису та аудіювання, щоб вільно володіти англійською мовою в авіації.',
        },
        simulator:{
          title: 'Симулятор',
          description: 'Практика в симуляторі - це чудовий спосіб говорити, не перебуваючи в небі чи в класі.',
        },
        questions:{
          title: 'Підготовка до іспиту',
          description: 'Отримайте доступ до офіційних питань і відповідей ECQB-PPL у сучасному оформленні.',
        },
        api:{
          title: 'Доступ до API',
          description: 'Отримайте доступ до нашого API та інтегруйте його у власні додатки.',
        },
        tools :{
          title: 'Інструменти',
          description: 'Різні інструменти, які полегшать ваше життя пілота.',
        },
      },
      singlepage: {
        product: 'Продукт',
        configure: 'Налаштувати',
        quantity: 'Кількість',
        subscribe: 'Підписатися',
        buy: 'Купити',
        pricing: 'Ціни',
        waver: 'Я погоджуюсь, що LATC надасть доступ негайно, і я цим самим відмовляюсь від свого права на відмову.',
        rightwithdrawal: 'Право на відмову',
        addpaymentmethod: 'Додати спосіб оплати',
      }
    },
  }
}
